import 'css/index.css';
import 'common-bootstrap';
import '@ardoq/typography/src/fonts/style.css';
import '@ardoq/icons/dist/fontIcons.css';

import Cookie from 'cookie_js';
import { initI18n } from '@ardoq/i18n';
import { logError } from '@ardoq/logging';
import { initApplication } from 'presentation/appLoader';
import { initializeArdoqPackages } from 'initializeArdoqPackages';
import { initializeModelInterfaces } from 'modelInterface/initializeModelInterfaces';
import { DEFAULT_I18N_CONFIG } from 'localeResources';
import { organizationNameFromQueryString } from 'utils/organizationNameFromQueryString';
import { startLayoutWorkerWhenIdle } from 'tabview/graphComponent/layoutWorker';

const newOrg = organizationNameFromQueryString();
const org = Cookie.get('organization');
if (newOrg && org !== newOrg) {
  if (window.confirm(`Switch to organization ${newOrg}?`)) {
    Cookie.set(
      {
        organization: newOrg,
      },
      {
        path: '/',
      }
    );
  }
}
(async () => {
  await initI18n(DEFAULT_I18N_CONFIG);
  initializeArdoqPackages();
  initializeModelInterfaces();
  initApplication();
  startLayoutWorkerWhenIdle();
})().catch(error => logError(error, 'Presentation bootstrap failed'));
